module.exports = __webpack_public_path__ + "img/collectIpkeepIcon.d539f57c.png";